const step5DefaultState = {
  employeesInPool: 0,
};

export default step5DefaultState;